// i18n.js
import i18n from "i18next"
import { initReactI18next } from "react-i18next"

import translationEN from "./locales/eng/translation.json"
import translationAR from "./locales/ar/translation.json"

// The translations
const resources = {
  en: {
    translation: translationEN,
  },
  ar: {
    translation: translationAR,
  },
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "ar", // default language
    fallbackLng: "ar", // fallback language in case translation is missing
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

export default i18n
